import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import DataService from '../../services/data.service';
import AnimateOnScroll from '../common/animate';
import LoaderOverlay from '../common/loader.component';

const Services = () => {
  const [serviceLinks, setServiceLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServicePages();
  }, []);

  const fetchServicePages = async () => {
    try {
      const response = await DataService.getPublicSeoPages();
      if (response.data) {
        setServiceLinks(response.data.services || []);
      }
    } catch (error) {
      console.error('Error fetching service pages:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Our Services | Divine Blush Beauty</title>
        <meta name="description" content="Explore our range of beauty services including facials, hair styling, makeup, and more at Divine Blush Beauty in Regina." />
        <link rel="canonical" href="https://www.divineblushbeauty.ca/services" />
      </Helmet>

      <LoaderOverlay loading={loading} />

      <section
        className="hero-wrap hero-wrap-2"
        style={{
          backgroundImage: 'url("/images/bb.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          zIndex: 1
        }}
      >
        <div className="overlay" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} />
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="col-md-9 text-center" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
              <h1 style={{
                color: '#fff',
                fontSize: '48px',
                fontWeight: '700',
                marginBottom: '20px',
                textShadow: '2px 2px 8px rgba(0,0,0,0.3)'
              }}>
                Our Services
              </h1>
              <p style={{
                color: '#fff',
                fontSize: '18px',
                lineHeight: '1.6',
                maxWidth: '700px',
                margin: '0 auto',
                textShadow: '1px 1px 4px rgba(0,0,0,0.3)'
              }}>
                Discover our comprehensive range of beauty and wellness services designed to help you look and feel your best.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ftco-section">
        <div className="container">
          {serviceLinks.length > 0 ? (
            <div className="row">
              {serviceLinks.map((service, index) => (
                <div className="col-md-6 col-lg-4 mb-4" key={service.id}>
                  <AnimateOnScroll>
                    <div className="service-card h-100">
                      <div className="card h-100 shadow-sm">
                        <div className="card-body d-flex flex-column">
                          <h5 className="card-title">{service.title}</h5>
                          {service.meta_description && (
                            <p className="card-text text-muted flex-grow-1">
                              {service.meta_description}
                            </p>
                          )}
                          <Link
                            to={`/${service.slug}`}
                            className="btn btn-primary mt-3"
                          >
                            Learn More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </AnimateOnScroll>
                </div>
              ))}
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12 text-center">
                <p>No services available at the moment.</p>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Services;
